import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../services/dashboard.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { PrintService } from 'app/services/print.service';

@Component({
	selector: 'app-need-bin-location',
	templateUrl: './need-bin-location.component.html',
	styleUrls: ['./need-bin-location.component.scss']
})
export class NeedBinLocationComponent implements OnInit {
	needBitItems: any[] = [];
	filteredNeedBinItems: any[] = [];
	locations: any[] = [];
	selectedLoc = '';
	color = 'blue';
	filename = 'needs_bin';
	exporting = false;
	loading = true;
	@ViewChild('print_table') printtable: ElementRef;
	subscritionsactive: any = false;

	constructor(
		private dashboardService: DashboardService,
		private globalSearchService: GlobalSearchService,
		private router: Router,
		private location: Location,
		private route: ActivatedRoute,
		private printService: PrintService
	) {
		this.color = this.globalSearchService.getColor();
	}

	ngOnInit(): void {
		this.globalSearchService.locations.subscribe(locs => {
			this.locations = locs || [];
			this.loadData();
		});
	}

	loadData(): void {
		if (this.subscritionsactive) {
			this.subscritionsactive.unsubscribe();
		}
		this.loading = true;
		this.subscritionsactive = this.dashboardService.getNeedLocation().subscribe((results: any) => {
			this.loading = false;
			this.needBitItems = results.data || [];
			this.filteredNeedBinItems = this.needBitItems;
		});
	}

	applyLocationFilter(loccode: string): void {
		if (!loccode) {
			this.filteredNeedBinItems = this.needBitItems;
			return;
		}

		const result = [];
		for (const item of this.needBitItems) {
			const matching = item.locations?.filter(loc => loc.loccode === loccode) || [];
			if (matching.length > 0) {
				result.push({ ...item, locations: matching });
			}
		}
		this.filteredNeedBinItems = result;
	}

	exportPdf(): void {
		const encoded = btoa(this.printtable.nativeElement.innerHTML);
		const now = new Date();
		const data = {
			content: encoded,
			filename: this.filename,
			title: 'Items Needing Bin Locations',
			subtitle: `Created: ${now.toLocaleDateString()} ${now.toLocaleTimeString()}`
		};

		this.exporting = true;
		this.printService.pdf(data).subscribe((result: any) => {
			this.exporting = false;
			this.globalSearchService.downloadPdf(result.content, data.filename);
		});
	}

	exportXls(): void {
		const encoded = btoa(this.printtable.nativeElement.innerHTML);
		const now = new Date();
		const data = {
			content: encoded,
			filename: this.filename,
			title: 'Items Needing Bin Locations',
			subtitle: `Created: ${now.toLocaleDateString()} ${now.toLocaleTimeString()}`
		};

		this.exporting = true;
		this.printService.xls(data).subscribe((result: any) => {
			this.exporting = false;
			this.globalSearchService.downloadXls(result.content, data.filename);
		});
	}

	viewItem(item: any): void {
		this.router.navigate(['/inventory/view/' + item.stockid]);
	}

	back(): void {
		this.location.back();
	}

	ngOnDestroy(): void {
		if (this.subscritionsactive) {
			this.subscritionsactive.unsubscribe();
		}
	}
}